define(function (require) {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/assetmanagement/commonassets/{0}',
		url: function () {
			return this.urlRoot.format(this.id);
		}
			
	});
});
